export const INITIAL = "initial";
export const RUNNING = "running";
export const FINISHED = "finished";
export const FAILURE = "failure";
